<template>
    <section>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card survey-card">
                        <div class="card-header">
                            <!-- <template v-if="urlParams">
                                Survey {{ urlParams.survey_guid }}-{{ urlParams.task_id }}-{{ urlParams.task_user }}
                            </template> -->
                            <template v-if="localProject">
                                <div class="row">
                                    <div class="col-md-6">
                                        <ul class="list-group">
                                            <!-- <li class="list-group-item"><b>Ghost:</b> {{ localProject.company.username }}</li> -->
                                            <li class="list-group-item"><b>Matricola:</b> {{ localProject.company.username }}</li>
                                            <li class="list-group-item"><b>Missione:</b> {{ localProject.project_name }}</li>
                                        </ul>
                                    </div>
                                    <div class="col-md-6">
                                        <ul class="list-group">
                                            <li class="list-group-item"><b>Tratta:</b> {{ localProject.localTask.task_name }}</li>
                                            <li class="list-group-item"><b>Data Tratta:</b> {{ taskDate }}</li>
                                            <!-- <li class="list-group-item"><b>Aperto da:</b> {{ localProject.creator.username }}</li> -->
                                            <!-- <li class="list-group-item"><b>Creato il:</b> {{ localProject.localTask.created_at }}</li> -->
                                        </ul>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <strong>ATTENZIONE: </strong> Mancano dei parametri necessari.
                            </template>
                        </div>
                        <div class="card-body p-0" v-if="survey">
                            <survey v-if="json" :survey="survey" class="survey"></survey>
                        </div>
                        <!-- <div class="card-footer">

                        </div> -->
                    </div>
                </div>
            </div>
            <span v-if="survey && survey.state === 'completed'" class="countdown">
                {{ seconds }}
            </span>
        </div>
    </section>
</template>

<script>
import {
    CompilationService,
    UploadService
} from '@/common/api.service'
import * as SurveyVue from 'survey-vue'
SurveyVue.JsonObject.metaData.addProperty('questionbase', {
    name: 'infoPopup:html',
    default: ''
})
// SurveyVue.JsonObject.metaData.addProperty('questionbase', {
//     name: 'tag:text',
//     default: ''
// })
var Survey = SurveyVue.Survey
Survey.cssType = 'bootstrap'

var myCss = {
    rating: {
        root: 'rating-group',
        item: 'custom-rating-button'
    },
    navigationButton: 'btn btn-success rounded-0'
}
import base64url from 'base64url'
import {
    mapGetters
} from 'vuex'
import {
    GET_SINGLE
} from '@/store/actions.type'
import {
    MODULE_NAME
} from '@/store/modules/surveys.module'
import {
    MODULE_NAME as PROJECTS_MODULE_NAME
} from '@/store/modules/projects.module'

export default {
    name: 'survey-compiler',
    components: {
        Survey
    },
    data () {
        return {
            currentPageNo: 0,
            isCompleted: false,
            compilationData: false,
            isSaving: false,
            json: false,
            percent: null,
            seconds: 5,
            survey: null,
            urlParams: false,
            wave: null
        }
    },
    computed: {
        guid () {
            return this.$route.params.guid
        },
        ...mapGetters([
            'currentUser'
        ]),
        ...mapGetters({
            currentSurvey: `${MODULE_NAME}/getSingle`,
            currentProject: `${PROJECTS_MODULE_NAME}/getSingle`
        }),
        localProject () {
            if (this.currentProject && this.urlParams.task_id) {
                let cp = this.currentProject
                cp.localTask = cp.tasks.find((t) => {
                    return t.id === this.urlParams.task_id
                })
                return cp
            }
            return false
        },
        taskDate () {
            if (this.localProject.localTask) {
                return this.localProject.localTask.metas.filter((m) => {
                    return m.meta_key === 'route_date'
                })[0].value
            }
            return null
        }
    },
    mounted () {
        this.$nextTick(() => {
            if (this.urlParams) {
                this.fetchWave()
            }
        })
    },
    methods: {
        async loadProject () {
            if (!this.urlParams.project_id) return false
            let _projectId = this.urlParams.project_id
            // return new Promise((resolve, reject) => {
            this.$store.dispatch(`${PROJECTS_MODULE_NAME}/${GET_SINGLE}`, {
                id: _projectId
            }).then(() => {
                // console.log(this.currentProject)
                return true
            }).catch(() => {
                return false
            })
        },
        // Chiamo le API per recuperare eventuali compilazioni parziali (passando il GUID della checklist)
        async loadCompilation () {
            let _compiler = this.urlParams.task_id
            return new Promise((resolve, reject) => {
                CompilationService.query({
                    compiler: _compiler,
                    wave: this.urlParams.survey_guid
                }).then((res) => {
                    if (res.data.length) {
                        this.compilationData = JSON.parse(res.data[0].json)
                        this.isCompleted = this.compilationData.info.status === 'completed'
                        if (this.isCompleted) {
                            this.$swal('ATTENZIONE!', 'Questa survey è già stata completata, potrai consultarla in sola lettura.', 'warning')
                        }
                    }
                    resolve()
                }).catch(() => {
                    reject()
                })
            })
        },
        async fetchWave () {
            // Carico le informazioni riguardo al progetto
            await this.loadProject()
            // Aspetto la risposta dal recupero compilazioni parziali
            await this.loadCompilation()

            // Recupero il waveID necessario per recuperare il JSON della Survey da dare in pasto a SurveyJS
            let currentWaveID = 1
            // let currentWaveID = this.$route.params.id
            this.$store.dispatch(`${MODULE_NAME}/${GET_SINGLE}`, {
                id: currentWaveID
            }).then(() => {
                let _wave = this.currentSurvey.activeWave
                // this.$store.dispatch(`${MODULE_NAME}/${IS_LOADING}`, false)
                if (_wave) {
                    let _self = this

                    // Setto variabili locali
                    _self.wave = _wave
                    _self.json = _wave.json

                    /** !!!!! Inizializzazione SurveyJS !!!!!! */
                    _self.survey = new SurveyVue.Model(_self.json)
                    _self.survey.css = myCss
                    _self.survey.locale = 'it'
                    _self.survey.showQuestionNumbers = 'off'
                    _self.survey.questionTitleTemplate = '{title} {require}'
                    _self.survey.requiredText = ''

                    // Inietto la compilazione parziale (eventuale) in SurveyJS
                    if (_self.compilationData) _self.survey.data = _self.compilationData.compilation

                    // Recupero lo status dalle info della compilazione parziale (se presente) e lo imposto alla Survey locale
                    if (_self.compilationData) _self.survey.status = _self.compilationData.info.status

                    // Se la Survey è completed, la apro in sola lettura
                    if (this.isCompleted) _self.survey.mode = 'display'

                    // Aggiungo alcune classi alle domande che mi interessa customizzare la UI
                    _self.survey.onAfterRenderQuestion.add((survey, options) => {
                        if (options.question.infoPopup) {
                            var infoPopup = document.createElement('span')
                            infoPopup.className = 'moreInfo'
                            infoPopup.innerHTML = '<button>i</button>' + '<span>' + options.question.infoPopup + '</span>'
                            var header = options.htmlElement.querySelector('h5')
                            if (header) header.appendChild(infoPopup)
                        }
                    })

                    // Listener che osserva il cambio di ogni singola risposta
                    _self.survey.onValueChanged.add((survey) => {
                        // Calcolo la percentuale di risposte date
                        let totalQuestions = 0
                        let totalAnswers = 0
                        survey.pages.forEach(p => {
                            p.questions.forEach(q => {
                                if (q.isRequired) {
                                    totalQuestions++
                                    if (q.value !== undefined) {
                                        totalAnswers++
                                    }
                                }
                            })
                        })
                        _self.percent = totalAnswers / totalQuestions * 100
                        // console.log(`${totalAnswers}/ ${totalQuestions}`)
                        // var qn = options.question
                        // var qType = qn.getType()
                        // if (qType === 'radiogroup') {
                        //     var resume = JSON.stringify(survey.data, (key, value) => !key || key.includes('-Comment') ? value : undefined)
                        //     resume = JSON.parse(resume.replace(/-Comment/g, ''))
                        //     var resumeText = ''
                        //     for (var key in resume) {
                        //         if (resume.hasOwnProperty(key)) resumeText += key + ': ' + resume[key] + '\n'
                        //     }
                        //     survey.setValue('Dettaglio', resumeText)
                        //     qn.hasComment = !isNaN(parseInt(qn.value))
                        // }
                        if (_self.survey.state === 'running' && !_self.isSaving) _self.saveData()
                    })

                    // Listener che ascolta il caricamento dei files (beta)
                    _self.survey.onUploadFiles.add((survey, options) => {
                        let formData = new FormData()
                        // eslint-disable-next-line no-console
                        // console.log(options)
                        formData.append('file', options.files[0])
                        UploadService.upload(formData)
                            .then((
                                result
                            ) => {
                                // eslint-disable-next-line no-console
                                // console.log(result)
                                options.callback('success',
                                    options.files.map(file => {
                                        return {
                                            file: file,
                                            content: result.data[0]
                                        }
                                    })
                                )
                            }).catch(() => {
                                this.$swal('Oooops!', 'Si è verificato un problema', 'error')
                            })
                    })

                    // Aggiungo classe custom alle domande obbligatorie alla validazione della pagina (NON VA!!!!!!)
                    _self.survey.onValidatedErrorsOnCurrentPage.add(function (survey, options) {
                        if (options.questions.length) {
                            options.questions.forEach(q => {
                                if (q.isRequired) {
                                    let qClasses = q.cssClasses
                                    qClasses.title = 'sq-title-required'
                                }
                            })
                        }
                    })
                    // Listener che salva il questionario alla fine
                    _self.survey.onComplete.add(() => {
                        if (_self.survey.state === 'completed') {
                            _self.isCompleted = true
                            _self.saveData()
                            setInterval(() => {
                                _self.seconds--
                            }, 1000)
                            setTimeout(() => {
                                _self.$router.replace('/')
                            }, 5000)
                        }
                        // setTimeout(() => {
                        //     _self.$router.replace('/')
                        // }, 5000)
                    })
                }
            })
        },
        saveData () {
            // this.$store.dispatch(`${MODULE_NAME}/${IS_LOADING}`, true)
            this.isSaving = true
            var data = {}
            data.compilation = this.survey.data
            // Aggiungo alcuni valori manualmente
            // Inietto la tratta come risposta del questionario (17072020)
            console.log(this.localProject.localTask.task_name)
            if (this.localProject.localTask) data.compilation['ROUTE'] = this.localProject.localTask.task_name

            data.info = {
                progress: this.survey.state === 'completed' ? 100 : this.percent,
                survey: this.wave.survey,
                wave: this.wave.id,
                compiler: this.urlParams.task_id,
                user: this.currentUser.id,
                status: this.survey.state,
                language: 'it'
            }
            CompilationService.insert(data).finally(() => {
                // this.$store.dispatch(`${MODULE_NAME}/${IS_LOADING}`, false)
                this.isSaving = false
            })
        }
    },
    beforeRouteEnter (to, from, next) {
        let queryString = to.params.guid
        // let queryString = to.fullPath ? to.fullPath.split('?')[1] : ''
        let urlParams = queryString ? base64url.decode(queryString) : false
        // console.log(urlParams)
        next(vm => {
            if (urlParams) {
                // Converto i parametri dell'url in oggetto js
                let params = urlParams.split('&')
                var obj = {}
                for (var i = 0; i < params.length; i++) {
                    var split = params[i].split('=')
                    obj[split[0].trim()] = parseInt(split[1].trim())
                }
                vm.urlParams = obj
            }
        })
    }
}
</script>
<style lang="scss">
@media screen and (max-width: 768px) {
    .checkbox, .radio {
        margin-bottom: 20px !important;
    }
    .sv_qstn {
        width: 100% !important;
    }
    .sv-q-column-4 {
            width: 100% !important;
            max-width: 100% !important;
        }
}
</style>
